<div class="coming-soon-dialog">
  <div class="dialog-content">
    <button class="close-btn" (click)="closeDialog()">
      <i class="pi pi-times"></i>
    </button>

    <div class="dialog-body">
      <div class="image-container">
        <img src="assets/images/coming-soon-pivot.svg" alt="Coming Soon" />
      </div>

      <h2 class="title">A Fresh Look is Coming Soon</h2>

      <p class="message">
        Get ready for the new us. We're rebranding with a new name and fresh interface. Same flow,
        upgraded experience. Stay tuned!
      </p>

      <button class="pg-button" (click)="closeDialog()">Okay</button>
    </div>
  </div>
</div>
